/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';
import { CursorManager } from '../../core/navigation';

const CursorEvents: FunctionComponent = (): JSX.Element => {
    useEffect(() => {
        window.addEventListener('message', (event) => {
            const data = event?.data;
            if (data.type !== CursorManager.SERVICE_NAME) {
                return;
            }

            CursorManager.onChange(data.response?.visibility);
        });

        return () => {
            window.removeEventListener('message', () => {});
        };
    }, []);

    return <></>;
};

export default CursorEvents;
